<div
  [class]="
    'flex items-center gap-2 px-3 py-4 rounded-xl ' +
    (config().variant === 'primary' ? 'bg-(--infobanner-primary-background)' : 'bg-(--infobanner-danger-background)')
  "
>
  @if (config().icon) {
    <app-icon
      [name]="config().icon!"
      size="24"
      [color]="
        config().variant === 'primary' ? 'var(--infobanner-primary-icon-color)' : 'var(--infobanner-danger-icon-color)'
      "
    ></app-icon>
  }
  <p
    [class]="
      'text-xs font-bold ' +
      (config().variant === 'primary' ? 'text-(--infobanner-primary-color)' : 'text-(--infobanner-danger-color)')
    "
  >
    {{ config().text }}
  </p>
  @if (config().button) {
    <button
      type="button"
      class="ml-auto shrink-0 text-xs font-bold bg-transparent border-none cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
      [class]="
        config().variant === 'primary' ? 'text-(--infobanner-primary-color)' : 'text-(--infobanner-danger-color)'
      "
      [disabled]="config().button?.loading ?? false"
      (click)="onButtonClick()"
    >
      {{ config().button?.label }}
    </button>
  }
</div>
